import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { TermsContext } from "../../utils/Context";
import { SINGLE, Selector } from "../Selectors/Selector";

const CurriculumMapTermSelect = ({
  id = "curriculum-map-term-select",
  label,
  size = "medium",
  selectHandler,
  selectedTermId,
  allowCurrent = true,
}) => {
  const { t } = useTranslation();
  const { insightsTerms } = useContext(TermsContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let terms = insightsTerms.filter(
      (term) =>
        (new Date(term.start_at) <= new Date() &&
          new Date(term.end_at) >= new Date()) ||
        new Date(term.start_at) >= new Date()
    );
    if (!allowCurrent) {
      terms = terms.filter(
        (term) =>
          new Date(term.start_at) > new Date() ||
          new Date(term.end_at) < new Date()
      );
    }
    terms = terms.sort((a, b) => new Date(a.start_at) - new Date(b.start_at));
    setOptions(
      terms.map((term) => {
        if (
          new Date(term.start_at) <= new Date() &&
          new Date(term.end_at) >= new Date()
        ) {
          return {
            ...term,
            label: `${term.name} (${t("curriculumMap.current")})`,
          };
        } else {
          return { ...term, label: term.name };
        }
      })
    );
  }, [insightsTerms]);

  const handleSelect = (termId) => {
    const insightsTerm = options.find((term) => term.id === termId);
    selectHandler(insightsTerm);
  };

  return (
    <Selector
      id={id}
      type={SINGLE}
      size={size}
      label={label}
      options={options}
      selectHandler={handleSelect}
      selectedItemId={selectedTermId}
    />
  );
};

export default CurriculumMapTermSelect;
